/* eslint-disable import/no-anonymous-default-export */
import auth from "./auth";
import product from "./product";
import addbanner from "./addbanner";
export default {
  auth,
  product,
  addbanner,
};
